import type { IntakeFieldDef, IntakeFieldType } from "./intakeFields.js";

const FIELD_TYPES: IntakeFieldType[] = [
  "short_text",
  "long_text",
  "single_select",
  "multi_select",
  "phone",
  "email",
  "date",
  "address",
  "number",
  "boolean",
  "identifier",
];

/** Edits an ordered `IntakeFieldDef[]` -- the config half of the industry-dependent booking
 *  form (docs/architecture.md section 15). Used both when creating a service and when editing
 *  an existing one's field list. */
export function IntakeFieldListEditor({
  fields,
  onChange,
}: {
  fields: IntakeFieldDef[];
  onChange: (next: IntakeFieldDef[]) => void;
}) {
  function update(index: number, patch: Partial<IntakeFieldDef>) {
    onChange(fields.map((f, i) => (i === index ? { ...f, ...patch } : f)));
  }
  function remove(index: number) {
    onChange(fields.filter((_, i) => i !== index));
  }
  function add() {
    onChange([...fields, { key: `field_${fields.length + 1}`, label: "", type: "short_text" }]);
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {fields.map((f, i) => (
        <div key={i} style={{ display: "flex", gap: 6, alignItems: "flex-start", flexWrap: "wrap" }}>
          <input
            placeholder="Label"
            value={f.label}
            onChange={(e) => update(i, { label: e.target.value })}
            style={{ padding: 6, flex: 2, minWidth: 120 }}
          />
          <select value={f.type} onChange={(e) => update(i, { type: e.target.value as IntakeFieldType })} style={{ padding: 6 }}>
            {FIELD_TYPES.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
          {(f.type === "single_select" || f.type === "multi_select") && (
            <input
              placeholder="Options, comma separated"
              value={(f.options ?? []).join(", ")}
              onChange={(e) => update(i, { options: e.target.value.split(",").map((s) => s.trim()).filter(Boolean) })}
              style={{ padding: 6, flex: 2, minWidth: 160 }}
            />
          )}
          <label style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 4 }}>
            <input type="checkbox" checked={Boolean(f.required)} onChange={(e) => update(i, { required: e.target.checked })} />
            required
          </label>
          <button type="button" onClick={() => remove(i)} style={{ background: "none", border: "none", color: "var(--rc-danger)", cursor: "pointer" }}>
            Remove
          </button>
        </div>
      ))}
      <button type="button" onClick={add} style={{ alignSelf: "flex-start", padding: "4px 10px", fontSize: 13 }}>
        + Add field
      </button>
    </div>
  );
}
